export default __webpack_public_path__ + "images/WinterSettingsBackground.web.png";